import { MccsRoles } from '@/@types/generated'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const ApplicationRoles: MccsRoles[] = [
  MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
  MccsRoles.AUTONOMOUS_VEHICLE_USER,
  MccsRoles.MOTOR_CARRIER_OWNER,
  MccsRoles.MOTOR_CARRIER_USER,
  MccsRoles.LICENSING_AGENCY_OWNER,
  MccsRoles.LICENSING_AGENCY_USER,
  MccsRoles.INSURANCE_PROVIDER,
]

export const InternalRoles: MccsRoles[] = [
  MccsRoles.ADMINISTRATOR,
  MccsRoles.SYSTEM,
  MccsRoles.CHIEF_INVESTIGATOR,
  MccsRoles.INVESTIGATOR,
  MccsRoles.CREDENTIALING_ADMIN,
  MccsRoles.CREDENTIALING,
  MccsRoles.LEGAL,
  MccsRoles.FINANCE,
]
